import {TablePagination} from '@store/common/pagination.model';
import {createStore, withProps} from '@ngneat/elf';
import {TableConfig} from '@constants/table.constants';
import {withEntities} from '@ngneat/elf-entities';
import {InterfaceEntity, InterfaceEntityTypeEnum, InterfaceFilters} from '@store/settings/interface/interface.model';
import {withPagination} from '@ngneat/elf-pagination';
import {withRequestsStatus} from '@ngneat/elf-requests';

export interface InterfaceState {
  tablePagination: TablePagination;
  filters: InterfaceFilters;
}

export const interfaceStore = createStore(
  { name: 'interface' },
  withProps<InterfaceState>({
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination
    },
    filters: {
      search: '',
      entityType: InterfaceEntityTypeEnum.ORGANISATION
    }
  }),
  withEntities<InterfaceEntity>(),
  withPagination(),
  withRequestsStatus(),

);
